import { render, staticRenderFns } from "./AdminDocumentList.vue?vue&type=template&id=01f49d24&"
import script from "./AdminDocumentList.vue?vue&type=script&lang=js&"
export * from "./AdminDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports